/**
 * Enhances text elements for better readability in the cloned document
 */
export const enhanceTextElementsInDocument = (clonedDoc: Document): void => {
  // Force all text to dark color for consistent readability
  const textElements = clonedDoc.querySelectorAll('p, h1, h2, h3, h4, h5, h6, span, div');
  textElements.forEach(el => {
    if (el instanceof HTMLElement && el.textContent && el.textContent.trim() !== '') {
      const style = window.getComputedStyle(el);
      
      // Make all text dark for readability, keeping strong contrast
      el.style.color = '#000000';
      
      // Ensure text is not transparent
      el.style.opacity = '1';
      
      // Remove any text shadows
      el.style.textShadow = 'none';
      
      // Ensure consistent font rendering using setProperty instead of direct assignment
      // for vendor-prefixed properties
      el.style.setProperty('-webkit-font-smoothing', 'antialiased');
      el.style.setProperty('-moz-osx-font-smoothing', 'grayscale');
      
      // Add explicit letter spacing and font weight to improve clarity
      el.style.letterSpacing = 'normal';
      el.style.fontWeight = getComputedStyle(el).fontWeight;
    }
  });
  
  // Specifically target stage card text for consistency
  const stageCardTexts = clonedDoc.querySelectorAll('.stage-card p, .stage-card div, .stage-card h3');
  stageCardTexts.forEach(el => {
    if (el instanceof HTMLElement) {
      // Apply consistent styling for stage card text
      el.style.color = '#000000';
      el.style.fontWeight = getComputedStyle(el).fontWeight;
      el.style.fontFamily = '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif';
      el.style.textRendering = 'optimizeLegibility';
    }
  });
  
  // Make muted text slightly darker, but still distinguishable
  const mutedTexts = clonedDoc.querySelectorAll('.text-muted-foreground, .text-xs, .text-sm');
  mutedTexts.forEach(el => {
    if (el instanceof HTMLElement) {
      el.style.color = '#333333';
    }
  });
};
